// @ts-nocheck
import { useContext } from 'react';
import { ComplianceRequestContext, ConfigContext } from '@/context';
import { ConsentHistory } from './ConsentHistory';
import { PrivacyDisclosures } from './PrivacyDisclosures';
import { PrivacyOptions } from './PrivacyOptions';
import { PrivacyRequests } from './PrivacyRequests';

export function DataPrivacy(props) {
  const { complianceRequestList: { loaded = false, events } = {} } = useContext(
    ComplianceRequestContext,
  );
  const {
    privacyDisclosuresEnabled,
    consentHistoryEnabled,
    privacyRequestsEnabled,
  } = useContext(ConfigContext);

  return (
    <div className="flex flex-col space-y-6">
      {privacyDisclosuresEnabled && <PrivacyDisclosures {...props} />}
      {consentHistoryEnabled && <ConsentHistory {...props} />}
      {privacyRequestsEnabled && (
        <>
          {loaded && events.length > 0 && (
            <PrivacyRequests events={events} {...props} />
          )}
          <PrivacyOptions {...props} />
        </>
      )}
    </div>
  );
}
